import React, { useState } from "react";
import { useSnackbar } from "notistack";
import axios from "axios";
import BasePopup from "../../../Components/Base/BasePopup";
import DataGridComponent from "../../../Components/Forms/DataGridProComponent";

const ColunasGridNaoIniciadaPopup = (props: any) => {
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [responseRows, setResponseRows] = useState<any>({});
  const [currentRows, setCurrentRows] = useState<any[]>([]);
  const { enqueueSnackbar } = useSnackbar();

  const columns: any[] = [
    {
      dataIndex: "nome",
      title: "Coluna",
      minWidth: 250,
      flex: 1,
    },
  ];

  async function saveAsync() {
    if (!currentRows || currentRows.length === 0) {
        enqueueSnackbar("Selecione ao menos uma coluna para salvar.", {
        variant: "warning",
      });
      return;
    }

    try {
      document.body.style.cursor = "progress";

      await axios.post("colunasGridInsert", {
        grid: "nao_iniciada",
        idsSelecionados: currentRows.map((row: any) => ({id: row.id, visivel_grid: row.visivel_grid})),
      });

      enqueueSnackbar("Salvo com sucesso!", { variant: "success" });
      props.onClose();
    }
    catch (error) {
      enqueueSnackbar("Erro ao salvar!", { variant: "error" });
    }
    finally {
      document.body.style.cursor = "default";
    }
  }

  const atualizaListaBuscaCallBack = async () => {
    try {
      document.body.style.cursor = "progress";

      const response = await axios.get("colunaGridSelecao?grid=nao_iniciada");

      setResponseRows({
        data: response.data,
        total: response.data.length,
      });
    } catch (error) {
      console.error(error);
    } finally {
      document.body.style.cursor = "default";
    }
  };

  return (
    <BasePopup
      title="Colunas Grid Não Iniciadas"
      isOpen={props.isOpen}
      onClose={props.onClose}
      onClickFirstButtonPopupCallback={saveAsync}
      isPesquisa="false"
      confirmClose={true}
    >
      <DataGridComponent
        heightFix={230}
        responseRows={responseRows}
        hideButtons={false}
        hideEdit={true}
        directionOptions="left"
        hideDelete={true}
        showUpDownButtons={true}
        returnFullRowsSelection={true}
        checkboxSelectionAllAdvanced={false}
        columns={columns}
        paginationSide="client"
        checkboxSelection={true}
        checkboxKeyField="visivel_grid"
        setSelectedRows={setSelectedRows}
        setCurrentRows={setCurrentRows}
        rowsPerPageOptions={[100, 50, 20]}
        atualizaListaBuscaCallBack={atualizaListaBuscaCallBack}
      />
      
    </BasePopup>
  );
};

export default ColunasGridNaoIniciadaPopup;
